import * as React from "react";
const SvgFiRrSmog = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-smog_svg__a)">
      <path
        fill="#062147"
        d="M19 24h-2a1 1 0 1 1 0-2h2a1 1 0 0 1 0 2m-6 0H1a1 1 0 1 1 0-2h12a1 1 0 0 1 0 2m10-4H11a1 1 0 1 1 0-2h12a1 1 0 0 1 0 2M7 20H5a1 1 0 1 1 0-2h2a1 1 0 0 1 0 2m12-4h-2a1 1 0 1 1 0-2h2a1 1 0 0 1 0 2m-6 0H1a1 1 0 1 1 0-2h12a1 1 0 0 1 0 2m3-4a5 5 0 0 1-2.336-.579 6.27 6.27 0 0 1-5.536-.152.59.59 0 0 0-.57.028A5 5 0 0 1 .133 5.83a4.95 4.95 0 0 1 3.677-3.69 5.1 5.1 0 0 1 2.374 0 .28.28 0 0 0 .283-.075 6.033 6.033 0 0 1 8.8-.287c.065.065.217.22.734.22a4.98 4.98 0 0 1 3.9 1.874.4.4 0 0 0 .193.148 3.6 3.6 0 0 1 1.438.13 3.44 3.44 0 0 1 2.348 2.432 3.5 3.5 0 0 1-4.34 4.282c-.275-.079-.334-.032-.359-.01A4.93 4.93 0 0 1 16 12m-2.386-2.59c.344 0 .682.083.986.244a3.04 3.04 0 0 0 3.294-.327 2.27 2.27 0 0 1 2.2-.384 1.5 1.5 0 0 0 1.857-1.858 1.45 1.45 0 0 0-.978-1.014 1.6 1.6 0 0 0-.642-.06 2.23 2.23 0 0 1-1.984-.885c-1.04-1.6-3.36-.663-4.5-1.937a4.02 4.02 0 0 0-5.866.191 2.27 2.27 0 0 1-2.266.706 3.1 3.1 0 0 0-1.447 0 3 3 0 0 0-1.617 4.781 3.07 3.07 0 0 0 3.882.712 2.58 2.58 0 0 1 2.554-.065 4.06 4.06 0 0 0 3.638.1c.277-.134.581-.204.89-.205"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-smog_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSmog;
